import { APP_INITIALIZER, inject } from "@angular/core";
import { FeatureFlagService } from "../services/feature-flag.service";
import { catchError } from "rxjs/operators";
import { of } from "rxjs";

function initializeFeatureFlag(): () => Promise<void> {
  const featureFlagService = inject(FeatureFlagService);

  return () => {
    featureFlagService
      .fetchFeatureFlags()
      .pipe(
        catchError((error) => {
          console.error("Error fetching feature flags:", error);
          return of(null);
        }),
      )
      .subscribe();

    return Promise.resolve();
  };
}

export const provideFeatureFlag = () => ({
  provide: APP_INITIALIZER,
  useFactory: initializeFeatureFlag,
  deps: [],
  multi: true,
});
